import * as React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import Grid from "@mui/material/Grid2"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomerAccordion from './CustomerAccordion';
import CustomerSearchModal from './modals/CustomerSearchModal';
import { MuiTelInput } from 'mui-tel-input';
import { emailRegex } from '../Constants';

export default function CustomerSelection({ updateFunction, customerData, preferredPhone = '', preferredEmail = '', includePreferredContact = false, allowCreate = true, allowEdit = true, updatePreferredContact, showErrors }) {
    const [myCustomerData, setMyCustomerData] = React.useState(structuredClone(customerData))
    const [customerSearchModalOpen, setCustomerSearchModalOpen] = React.useState(false)

    const updateCreateNewCustomer = () => {
        if (myCustomerData.createNewCustomer) {
            myCustomerData.customer = {}
            myCustomerData.editedCustomer = {}
        } else {
            myCustomerData.customer = {}
            myCustomerData.editedCustomer = {}
        }
        myCustomerData.createNewCustomer = !myCustomerData.createNewCustomer
        updateFunction(myCustomerData)
    }

    React.useEffect(() => {
        setMyCustomerData(structuredClone(customerData))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData])

    return (
        (<Box>
            <h3>Customer</h3>
            <Grid container alignItems={"center"} justifyContent={'space-between'} sx={{ pb: 2 }}>
                <Grid>
                    <Button variant="contained" onClick={() => setCustomerSearchModalOpen(true)} disabled={myCustomerData.createNewCustomer}>Search For Customer</Button>
                </Grid>
                <Grid>
                    {allowCreate &&
                        <FormControlLabel
                            control={<Checkbox checked={myCustomerData.createNewCustomer}
                                onChange={updateCreateNewCustomer} />}
                            label="New Customer"
                            labelPlacement='start'
                        />
                    }
                </Grid>
            </Grid>
            <CustomerAccordion
                customer={myCustomerData.editingCustomer || myCustomerData.createNewCustomer ? myCustomerData.editedCustomer : myCustomerData.customer}
                default_expanded={false}
                editable={!myCustomerData.createNewCustomer && allowEdit}
                createNewCustomer={myCustomerData.createNewCustomer}
                editingAlert={(status) => { myCustomerData.editingCustomer = status; updateFunction(myCustomerData) }}
                updateCustomer={(customer) => { myCustomerData.editedCustomer = customer; updateFunction(myCustomerData) }}
            />
            {includePreferredContact &&
                <Accordion defaultExpanded={false}>

                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="customeraccordion-preferred-contact-content"
                        id="customeraccordion-preferred-contact-header"
                    >
                        <Typography>Preferred Contact</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2} columns={{ xs: 6, sm: 12 }}>
                            <Grid size={6}>
                                <MuiTelInput
                                    margin="dense"
                                    id="phone"
                                    label="Phone"
                                    type="tel"
                                    fullWidth
                                    variant="filled"
                                    value={`+1 ${preferredPhone ?? ""}`}
                                    onChange={(e, extra) => updatePreferredContact('phone', extra)}
                                    InputLabelProps={{ shrink: true }}
                                    onlyCountries={['US']}
                                    defaultCountry="US"
                                    forceCallingCode
                                    disableDropdown
                                    error={showErrors && !(/^\d{10}$/.test(preferredPhone) || preferredPhone.length === 0)}
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    margin="dense"
                                    id="email"
                                    label="Email"
                                    type="email"
                                    fullWidth
                                    variant="filled"
                                    value={preferredEmail ?? ""}
                                    onChange={(e) => updatePreferredContact('email', e.target.value)}
                                    error={showErrors && !(Boolean(preferredEmail.toLowerCase().match(emailRegex)) || preferredEmail.length === 0)}
                                />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            }
            <CustomerSearchModal
                open={customerSearchModalOpen}
                closeModal={(results) => {
                    setCustomerSearchModalOpen(false)
                    if (results) {
                        myCustomerData.customer = results
                        myCustomerData.editedCustomer = results
                        updateFunction(myCustomerData)
                    }
                }}
            />
        </Box >)
    );
}


